import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { SlugPage } from '@pages/slug-page/models';

@Injectable({ providedIn: 'root' })
export class SlugService extends ApiServiceBase<SlugPage> {
  constructor() {
    super('');
  }
}
